import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import LineTagService from '@/services/linetag.service';
import { store } from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddToBasketMultiple',
  props: {
    productIds: null,
    text: null,
    quantity: { default: 1 },
    disabled: { type: Boolean }
  },
  emits: ["added"],
  setup(__props: any, { emit }: { emit: ({(e: 'added'): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { productIds: string[], text?: string, quantity: number, disabled?: boolean }





function addToBasket(payload: AddToBasketWebRequest) {
    store.dispatch('basket/addToBasket', payload);
}

const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);

const pending = ref<boolean>(false);

function onAdd() {
    pending.value = true;

    // one call for each variant, but not in parallel
    for (let index = 0; index < props.productIds.length; index++) {
        const variantId = props.productIds[index];
        addToBasket({ id: variantId, quantity: props.quantity, reference: null, basketType: null, cordLength: null, serviceProductId: null, discountPercent: null, freeItem: false });
        LineTagService.trackAddCart();
    }

    pending.value = false;
    emit('added');
}

return { __sfc: true,props, emit, addToBasket, isBasketLocked, pending, onAdd }
}

})